import { apiSlice } from "../../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    subscribeData: builder.mutation({
      query: (formData) => ({
        url: "/schedule-screenshot-email",
        method: "POST",
        body: formData,
      }),
    }),
    searchAll: builder.query({
      query: (data) => ({
        url: "/search/all",
        method: "GET",
        params: {
          query: data,
        },
      }),
    }),
  }),
});

export const { useSubscribeDataMutation, useSearchAllQuery } = sqlApiSlice;
